// // dashboardDataContext.jsx
// import { createContext, useContext, useEffect, useState } from "react";

// export const DashboardDataCreateContext = createContext();

// export const DashboardDataProvider = ({ children }) => {
//     const [sidebarMini, setSidebarMini] = useState(false);
//     const [navbarFixed, setNavbarFixed] = useState(false);
//     const [isDark, setIsDark] = useState(false);
//     const [isThemeDirection, setIsThemeDirection] = useState(false);
//     const [topNavbarBgColor, setTopNavbarBgColor] = useState("white");
//     const [sidebarBgColor, setSidebarBgColor] = useState("white");
//     const [sidebarBgImg, setSidebarBgImg] = useState(null);
//     const [activeVariation, setActiveVariation] = useState("vertical");

//     useEffect(() => {
//         if (isThemeDirection) {
//             document
//                 .querySelector("body")
//                 .setAttribute("data-theme-direction", "rtl");
//         } else {
//             document
//                 .querySelector("body")
//                 .setAttribute("data-theme-direction", "ltr");
//         }
//     }, [isThemeDirection]);

//     useEffect(() => {
//         if (isDark) {
//             document.querySelector("body").setAttribute("data-theme", "dark");
//         } else {
//             document.querySelector("body").setAttribute("data-theme", "light");
//         }
//     }, [isDark]);

//     return (
//         <DashboardDataCreateContext.Provider
//             value={{
//                 sidebarMini,
//                 setSidebarMini,
//                 sidebarBgColor,
//                 setSidebarBgColor,
//                 topNavbarBgColor,
//                 setTopNavbarBgColor,
//                 navbarFixed,
//                 setNavbarFixed,
//                 isDark,
//                 setIsDark,
//                 sidebarBgImg,
//                 setSidebarBgImg,
//                 isThemeDirection,
//                 setIsThemeDirection,
//                 activeVariation,
//                 setActiveVariation,
//             }}
//         >
//             {children}
//         </DashboardDataCreateContext.Provider>
//     );
// };

// export const useDashboardDataContext = () => {
//     return useContext(DashboardDataCreateContext);
// };

import { createContext, useContext, useEffect, useState } from "react";

export const DashboardDataCreateContext = createContext();

export const DashboardDataProvider = ({ children }) => {
    const [sidebarMini, setSidebarMini] = useState(false);
    const [navbarFixed, setNavbarFixed] = useState(false);
    const [isDark, setIsDark] = useState(false);
    const [isThemeDirection, setIsThemeDirection] = useState(false);
    const [topNavbarBgColor, setTopNavbarBgColor] = useState("white");
    const [sidebarBgColor, setSidebarBgColor] = useState("white");
    const [sidebarBgImg, setSidebarBgImg] = useState(null);
    const [activeVariation, setActiveVariation] = useState("vertical");

    // 📌 Yangi state: mobile holatni aniqlash
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isThemeDirection) {
            document.body.setAttribute("data-theme-direction", "rtl");
        } else {
            document.body.setAttribute("data-theme-direction", "ltr");
        }
    }, [isThemeDirection]);

    useEffect(() => {
        if (isDark) {
            document.body.setAttribute("data-theme", "dark");
        } else {
            document.body.setAttribute("data-theme", "light");
        }
    }, [isDark]);

    return (
        <DashboardDataCreateContext.Provider
            value={{
                sidebarMini,
                setSidebarMini,
                sidebarBgColor,
                setSidebarBgColor,
                topNavbarBgColor,
                setTopNavbarBgColor,
                navbarFixed,
                setNavbarFixed,
                isDark,
                setIsDark,
                sidebarBgImg,
                setSidebarBgImg,
                isThemeDirection,
                setIsThemeDirection,
                activeVariation,
                setActiveVariation,
                isMobile, // 📌 qo‘shildi
            }}
        >
            {children}
        </DashboardDataCreateContext.Provider>
    );
};

export const useDashboardDataContext = () => {
    return useContext(DashboardDataCreateContext);
};
